import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Flex, Box, Text, Formik, ButtonFilled, Grid } from 'Components/Base';
import Loading from 'Components/Loading';

const { FormContainer, Form, FormikInput } = Formik;
const { Input, TextArea } = FormikInput;

const isPositiveNumber = (value) => /^\d+$/.test(value);

const ClearTicketForm = ({ onSubmit, loading, initialValues, children }) => {
  const { t } = useTranslation('classroom');

  const videoDetailFields = [
    {
      name: 'courseName',
      label: t('CLEAR_BY_ONDEMAND.FORM.COURSE_NAME.LABEL'),
    },
    {
      name: 'videoTitle',
      label: t('CLEAR_BY_ONDEMAND.FORM.VIDEO_TITLE.LABEL'),
    },
    {
      name: 'videoTime',
      label: t('CLEAR_BY_ONDEMAND.FORM.VIDEO_TIME.LABEL'),
    },
  ];

  const validateClearTicketForm = ({ question, bookNo, pageNo, questionNo, ...rest }) => {
    const error = {};

    if (!isPositiveNumber(bookNo)) error.bookNo = t('CLEAR_BY_ONDEMAND.FORM.BOOK_NO.INVALID');
    if (!isPositiveNumber(pageNo)) error.pageNo = t('CLEAR_BY_ONDEMAND.FORM.PAGE_NO.INVALID');
    if (!isPositiveNumber(questionNo)) {
      error.questionNo = t('CLEAR_BY_ONDEMAND.FORM.EXAM_NO.INVALID');
    }
    if (!question) error.question = t('CLEAR_BY_ONDEMAND.FORM.MESSAGE.REQUIRED');
    if (!bookNo) error.bookNo = t('CLEAR_BY_ONDEMAND.FORM.BOOK_NO.REQUIRED');
    if (!pageNo) error.pageNo = t('CLEAR_BY_ONDEMAND.FORM.PAGE_NO.REQUIRED');
    if (!questionNo) error.questionNo = t('CLEAR_BY_ONDEMAND.FORM.EXAM_NO.REQUIRED');

    return error;
  };

  return (
    <Flex flexDirection="column" width="100%">
      <Text color="greyscale.grey3" mt={4}>
        {t('CLEAR_BY_ONDEMAND.FORM.HEADER_CAPTION')}
      </Text>
      <Text textStyle={'subtitle1'} mt={6}>
        {t('CLEAR_BY_ONDEMAND.FORM.BOOK_TYPE')}
      </Text>
      <Flex mt={4} mb={7} alignItems="baseline">
        <Text textStyle={'heading5'} fontWeight={'normal'}>
          {t('CLEAR_BY_ONDEMAND.FORM.BOOK_ONLY')}
        </Text>
        <Text ml={1}>{`*${t('CLEAR_BY_ONDEMAND.FORM.ANSWER_IN_24HRS')}`}</Text>
      </Flex>
      {children}
      <FormContainer
        initialValues={initialValues}
        enableReinitialize
        onSubmit={onSubmit}
        validate={validateClearTicketForm}
      >
        <Form id="ondemand-clear-ticket-form">
          <TextArea
            name="question"
            label={
              <Text textStyle={'subtitle1'} display="inline-block">
                {t('CLEAR_BY_ONDEMAND.FORM.MESSAGE.LABEL')}
              </Text>
            }
            required
            placeholder={t('CLEAR_BY_ONDEMAND.FORM.MESSAGE.PLACEHOLDER')}
            rows={7}
            rowsMax={7}
          />
          <Text textStyle={'subtitle1'} mt={6}>
            {t('CLEAR_BY_ONDEMAND.FORM.MESSAGE_DETAILS')}
          </Text>
          <Grid gridTemplateColumns={'1fr 1fr'} gridGap={4} mt={4}>
            <Input
              name="bookNo"
              label={t('CLEAR_BY_ONDEMAND.FORM.BOOK_NO.LABEL')}
              required
              placeholder={t('CLEAR_BY_ONDEMAND.FORM.BOOK_NO.PLACEHOLDER')}
              type="number"
              inputProps={{ min: 0, pattern: '[0-9]*' }}
            />
            <Input
              name="pageNo"
              label={t('CLEAR_BY_ONDEMAND.FORM.PAGE_NO.LABEL')}
              required
              placeholder={t('CLEAR_BY_ONDEMAND.FORM.PAGE_NO.PLACEHOLDER')}
              type="number"
              inputProps={{ min: 0, pattern: '[0-9]*' }}
            />
            <Input
              name="questionNo"
              label={t('CLEAR_BY_ONDEMAND.FORM.EXAM_NO.LABEL')}
              required
              placeholder={t('CLEAR_BY_ONDEMAND.FORM.EXAM_NO.PLACEHOLDER')}
              type="number"
              inputProps={{ min: 0, pattern: '[0-9]*' }}
            />
          </Grid>

          {videoDetailFields.map((field) => (
            <Box key={field.name} mt={4}>
              <Input disabled {...field} />
            </Box>
          ))}

          <ButtonFilled mt={4} width={1} type="submit" borderRadius="8px" disabled={loading}>
            {loading ? <Loading width={20} height={20} /> : t('CLEAR_BY_ONDEMAND.FORM.SUBMIT')}
          </ButtonFilled>
        </Form>
      </FormContainer>
    </Flex>
  );
};

ClearTicketForm.propTypes = {
  onSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  loading: PropTypes.bool,
};
ClearTicketForm.defaultProps = {
  onSubmit: () => {},
};
export default ClearTicketForm;
